import { Inject } from '@odinjs/odin';

import { FormAPI } from '@philips-emr/tws-components';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';

import BaseController from '../BaseController';

@Controller({ fragment: 'mensalidade-observacoes' })
export default class MensalidadeObservacoesController extends BaseController {
  @Inject('form-obs')
  private formObs: FormAPI;

  @OnMount({ target: 'panel-obs' })
  onMountFormObs(): void {
    const data = this.context.getBulkData();

    this.formObs.setData(data);
  }
}
